import { InfoIconTooltip } from "@repo/ui/tooltip/infoIconTooltip";
import type { FC, ReactNode } from "react";

export interface ConfigurationFieldProps {
  label: string;
  children: ReactNode;
  description?: string;
  /** Where the description renders relative to the field's control. */
  descriptionPlacement?: "aboveContent" | "belowContent";
  /** Info-icon tooltip rendered next to the label. */
  labelTooltip?: string;
}

/**
 * A labeled wrapper around one settings control: a muted label (with an optional
 * info-icon tooltip) and an optional description above or below the control.
 * Shared by every automation settings field.
 */
export const ConfigurationField: FC<ConfigurationFieldProps> = (props) => {
  const {
    label,
    children,
    description,
    descriptionPlacement = "belowContent",
    labelTooltip,
  } = props;
  const descriptionNode = description ? (
    <p className="-mt-1 max-w-xl text-xs leading-5 text-muted-foreground">
      {description}
    </p>
  ) : null;

  return (
    <div className="flex min-w-0 flex-col gap-2">
      <div className="flex items-center gap-1 text-xs font-medium text-muted-foreground">
        {label}
        {labelTooltip ? (
          <InfoIconTooltip>{labelTooltip}</InfoIconTooltip>
        ) : null}
      </div>
      {descriptionPlacement === "aboveContent" ? descriptionNode : null}
      <div className="min-w-0">{children}</div>
      {descriptionPlacement === "belowContent" ? descriptionNode : null}
    </div>
  );
};
